<template>
  <button class="btn btn-outline btn-error" @click="openModal">
    <i class="fas fa-trash opacity-90"></i> Xóa chiến dịch
  </button>
  <dialog ref="dialogRef" class="modal">
    <div class="modal-box">
      <h3 class="mb-4 text-lg font-bold">Xác nhận xóa chiến dịch</h3>

      <div class="py-2">
        <div class="mb-1">
          Nhập <span class="font-bold">{{ campaign.name }}</span> để xác nhận
          xóa chiến dịch
        </div>
        <div class="w-full">
          <input
            class="input input-bordered w-full"
            v-model="confirmName"
            placeholder="Nhập tên chiến dịch để xác nhận"
          />
        </div>
      </div>

      <div class="modal-action">
        <button class="btn" @click="closeModal">Hủy</button>
        <button
          class="btn btn-error min-w-28"
          @click="handleConfirm"
          :disabled="campaign.name !== confirmName || isDeleting"
        >
          <span v-if="isDeleting">
            <i class="fa-solid fa-spinner fa-spin"></i>
          </span>
          <span v-else> Xác nhận </span>
        </button>
      </div>
    </div>
  </dialog>
</template>

<script setup lang="ts">
import { deleteCampaign } from "@/api/campaign";
import { useQueryClient } from "@tanstack/vue-query";
import { ref } from "vue";
import { toast } from "vue3-toastify";

interface CampaignData {
  id: string | number;
  name: string;
  description?: string;
}

interface Props {
  campaign: CampaignData;
}

const { campaign } = defineProps<Props>();

const dialogRef = ref<HTMLDialogElement | null>(null);
const confirmName = ref<string>("");
const isDeleting = ref(false);
const queryClient = useQueryClient();

const openModal = () => {
  confirmName.value = "";
  dialogRef.value?.showModal();
};

const closeModal = () => {
  dialogRef.value?.close();
  confirmName.value = "";
};

const handleConfirm = async () => {
  if (campaign.name !== confirmName.value) {
    return;
  }

  isDeleting.value = true;
  try {
    const ok = await deleteCampaign(String(campaign.id));
    if (!ok) throw new Error("Delete failed");
    toast.success("Xóa chiến dịch thành công!");
    closeModal();
    // Invalidate and refetch campaigns query
    queryClient.invalidateQueries({ queryKey: ["campaigns"] });
  } catch (error) {
    console.error(error);
    toast.error("Đã xảy ra lỗi khi xóa chiến dịch.");
  } finally {
    isDeleting.value = false;
  }
};
</script>
